export default "__VITE_ASSET__DfIb4$hf__"